import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IJobCardForm } from '@job-card/models/job-card';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';

@Component({
	selector: 'app-job-card-materials',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, StandardControlComponent],
	templateUrl: './job-card-materials.component.html',
	styleUrl: './job-card-materials.component.scss',
})
export class JobCardMaterialsComponent {
	@Input() form: FormGroup<IJobCardForm>;
	@Input() inventoryItems: Array<string> = [];
	@Output() addMaterial: EventEmitter<void> = new EventEmitter<void>();
	@Output() removeMaterial: EventEmitter<number> = new EventEmitter<number>();

	addMaterialRow() {
		this.addMaterial.emit();
	}

	removeMaterialRow(index: number) {
		this.removeMaterial.emit(index);
	}
}
